import { HttpErrorResponse } from "@angular/common/http";
import { Action } from "@ngrx/store";
import { CourseFeedback } from "src/app/shared/interfaces/feedback-course";
import { Guid } from "src/app/shared/types/guid";

export const FEEDBACK_REMIND_LATER_LOAD = "[Feedback Remind Later] Load";
export const FEEDBACK_REMIND_LATER_SUCCESS =
  "[Feedback Remind Later] Load success";
export const FEEDBACK_REMIND_LATER_FAIL = "[Feedback Remind Later] Load fail";

export class FeedbackRemindLaterLoad implements Action {
  readonly type = FEEDBACK_REMIND_LATER_LOAD;
  constructor(public CourseId: Guid) {}
}

export class FeedbackRemindLaterSuccess implements Action {
  readonly type = FEEDBACK_REMIND_LATER_SUCCESS;
}

export class FeedbackRemindLaterFailure implements Action {
  readonly type = FEEDBACK_REMIND_LATER_FAIL;
  constructor(public error: HttpErrorResponse) {}
}

export type FeedbackRemindLaterActions =
  | FeedbackRemindLaterLoad
  | FeedbackRemindLaterSuccess
  | FeedbackRemindLaterFailure;
